import { $applyNodeReplacement } from "lexical";
import { FileNode } from "./FileNode.js";
function $createFileNode(id, name, size) {
    return $applyNodeReplacement(new FileNode(id, name, size));
}
function $isFileNode(node) {
    return node instanceof FileNode;
}
export { $createFileNode, $isFileNode };
